/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { StartDaikinAuthPayload } from 'api/actions/start-daikin-auth/start-daikin-auth-payload';
import { StartDaikinAuthPathParameters } from 'api/actions/start-daikin-auth/start-daikin-auth-path-parameters';
import { StartDaikinAuthResponse } from 'api/actions/start-daikin-auth/start-daikin-auth-response';

type StartDaikinAuthQueryParameters = Record<string, any>;

/**
 * The path of the StartDaikinAuth action.
 */
export const startDaikinAuthActionPath = new SweetPath<keyof StartDaikinAuthPathParameters>('/daikin/auth/start', {
  path: '{param}',
});

/**
 * Creates a contextualized StartDaikinAuth actions.
 */
export default function createStartDaikinAuthAction(axios: AxiosInstance) {
  return function startDaikinAuthAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: StartDaikinAuthQueryParameters;
    payload: StartDaikinAuthPayload;
  }) {
    const path = startDaikinAuthActionPath.original;

    return axios.post<StartDaikinAuthResponse, StartDaikinAuthResponse, StartDaikinAuthPayload>(path, payload);
  };
}
